import styled, { createGlobalStyle } from "styled-components";
import { anchorBounce } from "./animations";

export const TutorialRoot = styled.div<{
	$landscapeScale: number;
	$portraitScale: number;
}>`
	position: relative;
	font-size: ${({ $portraitScale }) => `${$portraitScale * 10}px`};

	@media (orientation: landscape) {
		font-size: ${({ $landscapeScale }) => `${$landscapeScale * 10}px`};
	}
`;

export const TutorialV2GlobalStyles = createGlobalStyle`
	.tutorial-v2-anchor {
		animation: ${anchorBounce} 0.8s ease-in-out infinite;
	}

	@media (prefers-reduced-motion: reduce) {
		.tutorial-v2-anchor {
			animation: none;
		}
	}
`;
